/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import autoBind from 'auto-bind';
import Analytics from '../analytics/Analytics';

class PwaController {
  private static _instance: PwaController;
  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  private deferredPrompt?: any;
  private onPWAAvailable?: VoidFunction;
  private onPWAProcessed?: VoidFunction;

  constructor() {
    autoBind(this);
  }

  public begin(onPWAAvailable: VoidFunction, onPWAProcessed: VoidFunction) {
    this.onPWAAvailable = onPWAAvailable;
    this.onPWAProcessed = onPWAProcessed;
    window.addEventListener('beforeinstallprompt', this.onBeforeInstallPrompt);
    window.addEventListener('appinstalled', this.onAppInstalled);
  }

  public async onShowPWAPrompt() {
    if (!this.deferredPrompt) {
      return;
    }
    this.deferredPrompt.prompt();
    Analytics.log('navigation.pwa_prompt', 'show');

    const result = await this.deferredPrompt.userChoice;
    if (result.outcome === 'dismissed') {
      Analytics.log('navigation.pwa_prompt', 'rejected');
    }

    this.deferredPrompt = null;
    if (this.onPWAProcessed) {
      this.onPWAProcessed();
    }
  }

  private onBeforeInstallPrompt(event: Event) {
    this.deferredPrompt = event;
    if (this.onPWAAvailable) {
      this.onPWAAvailable();
    }
  }

  private onAppInstalled(event: Event) {
    this.deferredPrompt = null;
    Analytics.log('navigation.pwa_prompt', 'accepted');
  }
}

export default PwaController.instance;
